import React from "react";

import BasicRoute from "components/routes/BasicRoute";

import VariedadeConsulta from "entity/Variedade/components/VariedadeConsulta";
import VariedadeForm from "entity/Variedade/components/VariedadeForm";

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={["r9jrEQXznNgjrZTGCfch", "RECT03jkyTQW9B2OMz47"]} //admin ou tecnico
                uid="consulta-variedade"
                route="consulta-variedade"

                menuProps={{
                    text: "Variedades",
                    sequence: "111115",
                    iconName: "Grass",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: "Edit",
                    },
                }}

                element={<VariedadeConsulta />}
            />
            <BasicRoute uid="variedade" route="_variedade" element={<VariedadeForm />} />
        </>
    );
}
